@if (breadcrumbs() && breadcrumbs().length) {
    <ol class="breadcrumb">
        @for (breadcrumb of breadcrumbs(); track breadcrumb) {
            <li class="breadcrumb-item" [class.active]="breadcrumb.active">
                @if ("dropdown" in breadcrumb && breadcrumb.dropdown) {
                    <kui-dropdown [menu]="breadcrumb.dropdown" [style]="'none'">
                        @if (!breadcrumb.active) {
                            <ng-container>
                                <a>
                                    {{ breadcrumb.name }}
                                    <kui-icon name="arrow-drop-down"></kui-icon>
                                </a>
                            </ng-container>
                        }
                        @if (breadcrumb.active) {
                            <ng-container>
                                <span>
                                    {{ breadcrumb.name }}
                                    <kui-icon name="arrow-drop-down"></kui-icon>
                                </span>
                            </ng-container>
                        }
                    </kui-dropdown>
                }
                @if (!breadcrumb.active && "link" in breadcrumb && breadcrumb.link) {
                    <a [routerLink]="breadcrumb.link">{{ breadcrumb.name }}</a>
                }
                @if (breadcrumb.active && "link" in breadcrumb && breadcrumb.link) {
                    <span>{{ breadcrumb.name }}</span>
                }
            </li>
        }
    </ol>
}
